import { REDUX_STORE_SLICES } from '../services/exports/Constants';
import { SessionStorageReservedKey, removeSessionStorageKeyForAllCompanies } from '../hooks/global/useSessionStorage';
import { migratePersistedOrder } from '../utils/on-site';

// A cart saved with room service before table ordering, moved to pickup by the migrate below.
let migratedOffTable = false;

/**
 * redux-persist's `migrate`, run on every rehydrate, before anything renders. Carts saved before table
 * ordering (PROD-724) may hold the room-service method and venue: they go to pickup, and the tab's
 * "order method chosen" flag, which was for room service, is cleared so the shop asks again.
 */
export function migratePersistedState<T extends Record<string, any>>(state: T): Promise<T> {
  const cachedOrder = state?.[REDUX_STORE_SLICES.ORDER]?.cached_order;

  if (!cachedOrder) {
    return Promise.resolve(state);
  }

  const migrated = migratePersistedOrder(cachedOrder);

  if (migrated.method !== cachedOrder.method) {
    migratedOffTable = true;
    removeSessionStorageKeyForAllCompanies(SessionStorageReservedKey.OrderMethodInfoStatus);
  }

  return Promise.resolve({
    ...state,
    [REDUX_STORE_SLICES.ORDER]: {
      ...state[REDUX_STORE_SLICES.ORDER],
      cached_order: migrated,
    },
  });
}

/** Whether the last rehydrate moved a cart off its table; reading it resets it. */
export function takeMigratedOffTable(): boolean {
  const value = migratedOffTable;
  migratedOffTable = false;

  return value;
}
